import {
  AirbnbLogo,
  RobinhoodLogo,
  DysonLogo,
  ASMLLogo,
  ComcastLogo,
  HSBCLogo,
  MicrosoftLogo,
  NasdaqLogo,
  NetflixLogo,
  SalesforceLogo,
  SquareLogo,
  ProgressiveLogo,
  ElasticLogo,
  EricssonLogo,
  HPELogo,
  HubspotLogo,
  MutualOfOmahaLogo,
  RevolutLogo,
  DeliveryHeroLogo,
  SapLogo,
  LidlLogo,
} from '@/components/Logos';

export const brands = [
  SquareLogo,
  RobinhoodLogo,
  DysonLogo,
  ComcastLogo,
  NetflixLogo,
  ElasticLogo,
  EricssonLogo,
  HPELogo,
  HubspotLogo,
  SapLogo,
  LidlLogo,
];

export const brandsReversed = [
  RevolutLogo,
  DeliveryHeroLogo,
  ProgressiveLogo,
  AirbnbLogo,
  ASMLLogo,
  HSBCLogo,
  MicrosoftLogo,
  NasdaqLogo,
  SalesforceLogo,
  MutualOfOmahaLogo,
];

// TODO This list is currently missing the following LOGOs:
// Adobe
// American Express
// AppDynamics
// Bell
// Broadcom
// Cisco Systems
// Peleton
// Intuit
// Royal Bank of Scotland (RBS)
// DNB
// Wise
// Ford Motor Company
// Volvo
// Meetup
// Zalando
// Trip Advisor
// Reddit
// Zürcher Kantonalbank
